import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

/**
 * The standing "you need to sign in again" screen — never a blank redirect. Reached two ways:
 *  • `?reason=expired` — a silent token refresh failed (Task 4).
 *  • `?reason=ended`   — the session was ended in another tab (Task 3 cross-tab logout).
 * Both clear the local session before landing here; the only action is to sign in again.
 */
export function SessionExpiredPage() {
  const [params] = useSearchParams();
  const ended = params.get('reason') === 'ended';

  const title = ended ? 'Your session has ended' : 'Your session has expired';
  const description = ended
    ? 'You were signed out. Please sign in again to continue.'
    : 'For your security, please sign in again to continue.';

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '100vh', textAlign: 'center', p: 3 }}
    >
      <Typography variant="h5" fontWeight={700}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
      <Button component={RouterLink} to={ROUTES.login} variant="contained">
        Sign in again
      </Button>
    </Stack>
  );
}
